import React from "react";
import PropTypes from "prop-types";
import {withGoogleMap, GoogleMap, Marker, InfoWindow} from "react-google-maps";

class MapComponent extends React.Component {
  state = {
    activeMarker: null, // id of the marker showing InfoWindow
  };

  render() {
    const {markers, markersTitle, onMarkerClick, inTabs} = this.props;
    const height = inTabs ? "84.5vh" : "91vh";

    // Filter out invalid markers
    const validMarkers = markers?.filter(
      (m) =>
        m.lat !== undefined && m.lon !== undefined && !isNaN(parseFloat(m.lat)) && !isNaN(parseFloat(m.lon))
    );

    // Safe default center
    const defaultCenter =
      validMarkers && validMarkers.length > 0
        ? {lat: parseFloat(validMarkers[0].lat), lng: parseFloat(validMarkers[0].lon)}
        : {lat: 24.6545303, lng: 46.7135804};

    return (
      <GoogleMap defaultZoom={6} defaultCenter={defaultCenter}>
        {validMarkers.map((e, i) => (
          <Marker
            key={i}
            position={{lat: parseFloat(e.lat), lng: parseFloat(e.lon)}}
            title={e[markersTitle]}
            onClick={() => this.setState({activeMarker: e.id}, () => onMarkerClick(e.id, i, e))}
          >
            {/* {this.state.activeMarker === e.id && (
              <InfoWindow onCloseClick={() => this.setState({activeMarker: null})}>
                <div>{e[markersTitle]}</div>
              </InfoWindow>
            )} */}
          </Marker>
        ))}
      </GoogleMap>
    );
  }
}

const WrappedMap = withGoogleMap(MapComponent);

const CustomMap = (props) => {
  const height = props.inTabs ? "84.5vh" : "91vh";

  return (
    <WrappedMap
      {...props}
      containerElement={<div style={{height: height, width: "100%"}} />}
      mapElement={<div style={{height: "100%", width: "100%"}} />}
    />
  );
};

CustomMap.propTypes = {
  markers: PropTypes.array.isRequired,
  markersTitle: PropTypes.string.isRequired,
  onMarkerClick: PropTypes.func.isRequired,
  inTabs: PropTypes.bool,
};

export default CustomMap;
